

















































import { Vue, Component, Prop } from "vue-property-decorator";
import DialogSlot from "@/components/dialog/doalogSlot.vue";
import { EmptyForm } from "@/utils/baseFn";
import { indexPageUpdate } from "@/api/tenant/dataPage";
import { TableRowInfoList } from "@/types/tenant/dataPage";
@Component({
  components: {
    DialogSlot,
  },
})
export default class Edit extends Vue {
  @Prop() getIndexPageList!: Function;
  dialogSlotShow = false;
  form: TableRowInfoList = {
    name: "",
    introductions: "",
    remark: "",
    sketch: "",
    ratioValues: [],
    values: []
  };

  private show(data: TableRowInfoList) {
    this.form = data;
    this.dialogSlotShow = true;
  }

  private async handleConfirm() {
    const { form } = this;
    const { introductions, remark, sketch } = form;
    if (introductions === "" || remark === "" || sketch === "") {
      this.$message({
        type: "error",
        message: "请输入完整的信息再提交",
      });
    } else {
      //   ajax
      await indexPageUpdate(form);
      this.$message({
        type: "success",
        message: "更新成功",
      });
      EmptyForm(this.form);
      this.dialogSlotShow = false;
      this.getIndexPageList();
    }
  }

  private handleClose() {
    console.log("取消了");
    EmptyForm(this.form);
    this.dialogSlotShow = false;
  }
}
